import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-analisis',
  templateUrl: './analisis.component.html',
  styleUrls: ['./analisis.component.css']
})
export class AnalisisComponent implements OnInit {

  constructor(
    private router:Router,
  ) { }

  ngOnInit(): void {
  }

  IrAnalisisCHV(){
    this.router.navigate(['analisischv']);
  }

  IrAnalisisFIVI(){
    this.router.navigate(['analisisfivi']);
  }

}
